import React, { Component } from "react";

import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";

import ReactHtmlParser from "react-html-parser";
const home =
  '<ul> <li style="text-align: justify;">Estimation of daily evaporative fluxes for Indian region at an appropriate spatial framework</li> </ul> <ul style="text-align: justify;"> <li>Development of evaporative flux observing and monitoring system at spatial scales of watersheds/river-basins and land use/land cover units and temporal scales of pentads, dekads, fortnights, months and seasons.</li> </ul> <ul> <li style="text-align: justify;">Creation of long term data base of evaporative fluxes and design of structured query and analysis tools</li> </ul>';

export default class ETProjTeam extends Component {
  render() {
    return (
      <div
         className="cardeck_full"
      
      >
        <div
         className="carddeck_inner"
          style={{
         
            backgroundColor: colors.background,
          }}
        >
          <Slider />
          {/* <MDBCard style={{ width: "100%", }}>
            <MDBCardBody> */}
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div className="card" style={{ width: "100%", height: "500px" }}>
              <main style={{ flexGrow: "1", overflowX: "auto" }}>
                <div
                  className="card"
                  style={{ padding: "15px", width: "100%", height: "100%" }}
                >
                  {/* <main style={{flexGrow: "1", width:"100%", height:"100%", flexGrow:1, flexBasis:"content", alignSelf:"bsaeline"}}>
      <div className="card"> */}
                  <div className="card-body">
                    <h3 className="card-title" style={{ color: "#002171" }}>
                      Regional Evaporative Flux Monitoring System
                    </h3>
                    <hr />
                    {ReactHtmlParser(home)}
                  </div>
                </div>
              </main>
            </div>
          </main>
          {/* </MDBCardBody>
        </MDBCard> */}
        </div>
      </div>
    );
  }
}
